import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { WatchlistGridDataResponse } from "./watchlist-page.model";
import {
  WatchlistSharingLog,
  UserSuggestions,
} from "./share-watchlist-modal/share-watchlist.model";

@Injectable({
  providedIn: "root",
})
export class WatchlistPageService {
  apiEP: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getWatchlistsForUser(): Observable<any> {
    return this.http.get(`${this.apiEP}/watcher/get_watchers_only`);
  }

  deleteWatchlistidsForUser(watchlistInfo): Observable<any> {
    return this.http.post(
      `${this.apiEP}/watcher/delete_watcher/`,
      watchlistInfo,
    );
  }

  renameWatchlist(watchlistid: number, watchlistname: string): Observable<any> {
    const renameBody = { watchlistname, watchlistid };
    return this.http.post(
      `${this.apiEP}/watcher/edit_watchlist_name/`,
      renameBody,
    );
  }

  updateWatchlist(updatedWatchlistObj): Observable<any> {
    return this.http.post(
      `${this.apiEP}/watcher/update_watcher/`,
      updatedWatchlistObj,
    );
  }

  getWatchlistGridData(watchlistId): Observable<WatchlistGridDataResponse> {
    const queryParam = watchlistId ? `watchlistid=${watchlistId}` : "";
    return this.http.get<WatchlistGridDataResponse>(
      `${this.apiEP}/watcher/get_watchlist_grid_data/?${queryParam}`,
    );
  }

  getCompanyLastTransaction(
    watchlistId,
  ): Observable<WatchlistGridDataResponse> {
    const queryParam = watchlistId ? `watchlistid=${watchlistId}` : "";
    return this.http.get<WatchlistGridDataResponse>(
      `${this.apiEP}/watcher/get_company_last_transaction/?${queryParam}`,
    );
  }

  getWatchlistSharingLog(watchlistId): Observable<any> {
    return this.http.get(
      `${this.apiEP}/watcher/get_shared_watchlist/?watchlistid=${watchlistId}`,
    );
  }

  getLatestWatchlistId(): Observable<any> {
    return this.http.get<any>(
      `${this.apiEP}/watcher/get_my_latest_watchlist_id/`,
    );
  }

  shareWatchlist(
    watchlistId: number,
    emailid: string,
  ): Observable<WatchlistSharingLog> {
    return this.http.post<WatchlistSharingLog>(
      `${this.apiEP}/watcher/add_user_watchlist/`,
      { watcherid: watchlistId, emailid: [emailid] },
    );
  }

  // /watcher/get_user_suggestions/?q=pratik
  getUserSuggestions(query: string): Observable<UserSuggestions> {
    return this.http.get<UserSuggestions>(
      `${this.apiEP}/watcher/get_user_suggestions/?q=${query}&internal_user_filter=true`,
    );
  }

  getLatestModelSourceName(
    sourceId: string | number,
    ticker: string,
  ): Observable<any> {
    return this.http.get(
      `${this.apiEP}/watcher/latest_model_source_name/?sourceid=${sourceId}&ticker=${ticker}`,
    );
  }

  getFilterData(watchlistId: string, column: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/watcher/get_filter_data/?watchlistid=${watchlistId}&field=${column}`,
    );
  }
}
